import React, { useState } from "react";
import { RemoveModal } from "src/app/modals/RemoveModal/RemoveModal";
import { showErrorToast } from "src/utils/methods";
import { API_URLS } from "src/utils/API_URLS";
import axios from "axios";
import { SocialInsightsDashboardListElement } from "src/redux/insights-dashboard/utils";
import { getDashboardList } from "src/redux";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/reducers";
import { showToast } from "src/app/methods/showToast";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

interface Props {
  data: SocialInsightsDashboardListElement;
  onClose: () => void;
}

export const RemoveDashboardModal = (props: Props) => {
  const { data, onClose } = props;

  const [loading, setLoading] = useState(false);

  const { activeWorkspaceUuid } = useSelector(
    (state: RootState) => state.mainReducer,
  );

  const dispatch = useDispatch();

  const removeItem = async () => {
    setLoading(true);

    try {
      await axios.delete(
        API_URLS.deleteInsightsDashboard
          .replace(":workspaceUuid:", activeWorkspaceUuid)
          .replace(":dashboardUuid:", data.uuid),
      );
      dispatch(getDashboardList(activeWorkspaceUuid));
      showToast(
        "info",
        <IDHFormattedMessage id="ws_info" defaultMessage="Info" />,
        <IDHFormattedMessage
          id="ws_dashboard_has_been_successfully_removed"
          defaultMessage="Dashboard has been successfully removed"
        />,
      );
      onClose();
    } catch (err) {
      showErrorToast();
    } finally {
      setLoading(false);
    }
  };

  return (
    <RemoveModal
      onClose={onClose}
      objectNames={[data.name]}
      removeFunction={removeItem}
      loading={loading}
    />
  );
};
